import React, { useState } from 'react';
import { Link } from 'react-router-dom';

// Layout
import LayoutWithOutNavBar from '../../components/layout/LayoutWithOutNavBar';

// Services
import { requestPasswordReset } from '../../services/userAPIService';

const PasswordResetPage = () => {
  const [email, setEmail] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setError('');

    try {
      await requestPasswordReset(email);
      setSuccess(true);
    } catch (err) {
      setError(err.message || 'Something went wrong. Please try again.');
    } finally {
      setIsLoading(false);
    }
  };

  if (success) {
    return (
      <LayoutWithOutNavBar>
        <div className="min-h-screen hero bg-base-200">
          <div className="hero-content flex-col w-full max-w-md py-8 px-4">
            <div className="text-center mb-8">
              <h1 className="text-4xl font-bold">E-Mail versendet</h1>
              <div className="h-1 w-24 bg-success mx-auto mt-3 rounded-full"></div>
            </div>

            <div className="card w-full shadow-2xl bg-base-100">
              <div className="card-body text-center space-y-6">
                <div className="flex justify-center">
                  <div className="rounded-full bg-success/10 p-4">
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-12 w-12 text-success" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                    </svg>
                  </div>
                </div>

                <p className="text-base-content/80">
                  Falls ein Konto mit der E-Mail-Adresse <span className="font-medium">{email}</span> existiert, 
                  erhältst du in Kürze eine Nachricht mit weiteren Anweisungen.
                </p>

                <Link to="/login" className="btn btn-primary w-full">
                  Zurück zum Login
                </Link>
              </div>
            </div>
          </div>
        </div>
      </LayoutWithOutNavBar>
    );
  }

  return (
    <LayoutWithOutNavBar>
      <div className="min-h-screen hero bg-base-200">
        <div className="hero-content flex-col w-full max-w-md py-8 px-4">
          <div className="text-center mb-8">
            <h1 className="text-4xl font-bold">Passwort zurücksetzen</h1>
            <div className="h-1 w-24 bg-primary mx-auto mt-3 rounded-full"></div>
          </div>

          <div className="card w-full shadow-2xl bg-base-100">
            <div className="card-body space-y-6">
              {error && (
                <div className="alert alert-error shadow-lg">
                  <svg xmlns="http://www.w3.org/2000/svg" className="stroke-current shrink-0 h-6 w-6" fill="none" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M10 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2m7-2a9 9 0 11-18 0 9 9 0 0118 0z" />
                  </svg>
                  <span>{error}</span>
                </div>
              )}

              <p className="text-base-content/80">
                Gib deine E-Mail-Adresse ein und wir senden dir einen Link zum Zurücksetzen deines Passworts.
              </p>

              <form onSubmit={handleSubmit} className="space-y-4">
                <div className="form-control">
                  <label className="label">
                    <span className="label-text font-medium">E-Mail</span>
                  </label>
                  <input 
                    type="email" 
                    placeholder="mail@beispiel.de"
                    className="input input-bordered input-primary" 
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                    disabled={isLoading}
                  />
                </div>

                <button 
                  type="submit" 
                  className="btn btn-primary w-full"
                  disabled={isLoading}
                >
                  {isLoading ? (
                    <>
                      <span className="loading loading-spinner"></span>
                      <span>Wird gesendet...</span>
                    </>
                  ) : 'Link zum Zurücksetzen senden'}
                </button>

                <div className="text-center">
                  <Link 
                    to="/login" 
                    className="link link-primary"
                  >
                    Zurück zum Login
                  </Link>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </LayoutWithOutNavBar>
  );
};

export default PasswordResetPage;